import { motion } from "framer-motion";
import { Sparkle } from "lucide-react";

export const QuoteDivider = () => (
  <div
    data-testid="quote-divider"
    className="relative py-6 flex items-center justify-center gap-5 overflow-hidden"
    aria-hidden="true"
  >
    <div className="h-px w-40 md:w-72 bg-gradient-to-l from-luxury-gold via-luxury-gold/50 to-transparent" />
    <motion.span
      animate={{ rotate: [0, 20, -20, 0], scale: [1, 1.25, 1] }}
      transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
      className="text-luxury-gold"
    >
      <Sparkle className="w-4 h-4" strokeWidth={1.5} />
    </motion.span>
    <div className="h-px w-40 md:w-72 bg-gradient-to-r from-luxury-gold via-luxury-gold/50 to-transparent" />
    <motion.span
      aria-hidden="true"
      animate={{ x: ["-42vw", "42vw"], opacity: [0, 1, 1, 0] }}
      transition={{ repeat: Infinity, duration: 6, ease: "easeInOut", repeatDelay: 2 }}
      className="absolute top-1/2 -translate-y-1/2 w-24 h-px bg-gradient-to-r from-transparent via-[#FFE9B8] to-transparent"
    />
  </div>
);
